import {H1, H2} from "../Headlines";
import Section from "./Section";
import {PlusCircleIcon} from "@heroicons/react/24/solid";
import Paragraph from "../Paragraph";
import React from "react";

type person = {
    name: string,
    href: string,
    imageUrl: string,
    imageObjectValue: string,
    bio: Array<string>,
}

const geschaeftsfuehrung: person[] = [
    {
        name: 'Tobias Michael-Weber',
        href: 'tobias_michael-weber',
        imageUrl: process.env.PUBLIC_URL + '/images/team/TobiasMichael-Weber.jpg',
        imageObjectValue: 'object-[0_28%]',
        bio: ['Geschäftsführer', 'Schornsteinfegermeister', 'Energie-Effizienz-Experte', 'Operatives Geschäft'],
    },
    {
        name: 'Benedikt Oppermann',
        href: 'benedikt_oppermann',
        imageUrl: process.env.PUBLIC_URL + '/images/team/BenediktOppermann.jpg',
        imageObjectValue: 'object-[0_30%]',
        bio: ['Geschäftsführer', 'Schornsteinfegermeister', 'Energie-Effizienz-Experte', 'Vertrieb', 'Finanzen'],
    },
]


const angestellte: person[] = [
    {
        name: 'Richard Scholz',
        href: 'richard_scholz',
        imageUrl: process.env.PUBLIC_URL + '/images/team/RichardScholz.jpg',
        imageObjectValue: 'object-[0_30%]',
        bio: ['Schornsteinfegermeister', 'Energieberater', 'Kundenbetreuung', 'Vor-Ort-Termine', 'CAD'],
    },
    {
        name: 'Sara Kleespies',
        href: 'sara_kleespies',
        imageUrl: process.env.PUBLIC_URL + '/images/team/SaraKleespies.jpg',
        imageObjectValue: 'object-[0_25%]',
        bio: ['Schornsteinfegermeisterin', 'Back-Office'],
    },
    {
        name: 'Darren Röll',
        href: 'darren_roell',
        imageUrl: process.env.PUBLIC_URL + '/images/team/DarrenRoell.jpg',
        imageObjectValue: 'object-[0_28%]',
        bio: ['Schornsteinfeger', 'Kundenbetreuung', 'Vor-Ort-Termine', 'CAD'],
    },
]

export default function UnserTeam({short = false}: { short?: boolean }) {
    return <>
        <Section id={'unser-team'}
                 className={'content-center justify-center items-center flex flex-col ' + (short ? '' : '!pt-0')}>
            {!short && <H1 id={'unser-team-headline'} className={'mb-12'}>Unser Team</H1>}
            {short && <H2 id={'unser-team-headline'} className={'mb-12'}>Unser Team</H2>}
            {!short &&
                <Paragraph className={'mb-12'}>
                    Unser Team der OMW-Energieberatung freut sich auf <a href={'#kontakt'} className={'underline hover:text-gray-900'}>Ihre
                    Kontaktanfrage</a>.</Paragraph>}
            <div className={'flex flex-wrap justify-center'}>
                {geschaeftsfuehrung.map((person) => (
                    <Sammelkarte mitarbeiter={person}/>
                ))}
            </div>
            <div className={'flex flex-wrap justify-center'}>
                {angestellte.map((person) => (
                    <Sammelkarte mitarbeiter={person}/>
                ))}
            </div>
        </Section>
    </>
}

function Sammelkarte({mitarbeiter}: { mitarbeiter: person }) {
    return <>
        <div key={mitarbeiter.name} id={mitarbeiter.href}
             className={'container m-4 bg-gradient-to-br from-zinc-300 from-20% via-slate-400 via-70% to-zinc-100 w-80 h-max rounded-2xl content-center justify-center shadow-2xl shadow-zinc-700 '}>
            <div className={''}>
                <div className={'bg-gradient-to-r from-green-700 to-green-600 m-4 p-2 max-w-full rounded-md'}>
                    <div className={'bg-green-100 rounded-md max-w-full h-64 border relative'}>
                        <img src={process.env.PUBLIC_URL + '/images/logo/omw-logo-black.svg'}
                             className={'px-2 pt-2 absolute top-0 right-0 z-20 w-20'} alt={'Logo OMW'}/>
                        {mitarbeiter.imageUrl !== '' && <img alt={"Bild " + mitarbeiter.name} src={mitarbeiter.imageUrl}
                                                             className={"aspect-[5/3] h-full rounded-md object-cover " + mitarbeiter.imageObjectValue}/>}
                        {mitarbeiter.imageUrl === '' &&
                            <img alt="Logo OMW" src={process.env.PUBLIC_URL + '/images/logo/omw-logo.svg'}
                                 className="p-2 mt-20 aspect-[5/3] w-auto rounded-md object-cover object-[0_30%] opacity-20"/>}
                    </div>
                    <div className={'mt-2'}>
                        <div
                            className={'bg-gradient-to-r from-green-100 via-green-50 to-green-200 rounded-md h-48 border border-green-300 opacity-80 z-20 relative'}>
                            <p className={'font-bold text-xl text-zinc-800 mt-2'}><span
                                className={'text-2xl'}>[</span>{mitarbeiter.name.toUpperCase()}<span
                                className={'text-2xl'}>]</span></p>
                            <hr className={'border border-zinc-400 m-3'}/>
                            <ul className={'text-left mt-2 ml-4 font-bold'}>
                                {mitarbeiter.bio.map((skill) => (
                                    <li key={skill}><PlusCircleIcon
                                        className={'h-6 float-left mr-2 text-slate-400 '}/>{skill}</li>
                                ))}
                            </ul>
                            <img src={process.env.PUBLIC_URL + '/images/logo/omw-logo.svg'}
                                 className={'opacity-10 px-2 pb-2 absolute bottom-0'}
                                 alt={'Logo OMW'}/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>
}